import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import { AuthProvider, Protected } from "@/lib/auth";
import { CookieBanner } from "@/components/CookieBanner";
import Landing from "@/pages/Landing";
import { Login, AuthVerify, PaymentSuccess, PaymentCancel, CreateAccount } from "@/pages/AuthPages";
import Dashboard from "@/pages/Dashboard";
import ModulePage from "@/pages/ModulePage";
import Legal from "@/pages/Legal";
import AdminPage from "@/pages/admin/AdminPage";

export default function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Landing />} />
          <Route path="/login" element={<Login />} />
          <Route path="/auth/verify" element={<AuthVerify />} />
          <Route path="/payment/success" element={<PaymentSuccess />} />
          <Route path="/payment/cancel" element={<PaymentCancel />} />
          <Route path="/legal/:slug" element={<Legal />} />
          <Route path="/dashboard" element={<Protected><Dashboard /></Protected>} />
          <Route path="/course/:slug" element={<Protected unlocked><ModulePage /></Protected>} />
          <Route path="/account/setup" element={<Protected><CreateAccount /></Protected>} />
          <Route path="/admin" element={<Protected admin><AdminPage /></Protected>} />
          <Route path="*" element={<Landing />} />
        </Routes>
        <CookieBanner />
      </BrowserRouter>
      <Toaster position="top-center" richColors />
    </AuthProvider>
  );
}
